// extracted by mini-css-extract-plugin
export default {"event-stat":"UserEvent_event-stat__VzqWu","title":"UserEvent_title__D-PIW","empty":"UserEvent_empty__V6mpH"};